module.exports = __webpack_public_path__ + "img/patent2.794ed4fe.jpg";